import { SvgIcon, SvgIconProps } from "designSystem/index";
import React, { FunctionComponent } from "react";
import { grey } from "designSystem/styles/color";

const FaceSelectBottomIcon: FunctionComponent<SvgIconProps> = ({ ...props }) => {
	return (
		<SvgIcon {...props} viewBox="0 0 16 16">
			<polygon fill={grey[900]} points="3.61 12.02 14.54 12.25 11.71 15.86 0.75 14.9 3.61 12.02" />
			<path d="M16,12.38V0H3.61L0,3.62H0V16H12.38L16,12.38Zm-12.38-1L1.46,13.52V5.07H3.62ZM5.07,5.07h5.86v5.86H5.07Zm7.31-.43,2.16-2.16v8.45H12.38Zm1.13-3.18L11.36,3.61H5.07V1.46Zm-9.89.6V3.61H2.06ZM2.49,14.55l2.15-2.17h6.29v2.17Zm9.89-.61V12.38h1.56Z" />
		</SvgIcon>
	);
};

export default FaceSelectBottomIcon;